import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BugReportDTO } from 'src/app/dtos/BugReportDTO';
import { ToastrService } from 'ngx-toastr';
import { BugModuleService } from 'src/app/services/bug-module/bug-module.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ImageDialogComponent } from '../image-dialog/image-dialog.component';
import { IssueStage } from 'src/app/services/bug-module/StageType-enum';
import {UserService} from 'src/app/services/user/user.service';

import { GenericConfirmationDialogComponent } from 'src/app/core/generic-confirmation-dialog/generic-confirmation-dialog.component';

@Component({
  selector: 'app-view-bug',
  templateUrl: './view-bug.component.html',
  styleUrls: ['./view-bug.component.scss']
})
export class ViewBugComponent implements OnInit {
  issue: BugReportDTO;
  issueId: string;
  updateStageSearch: string;
  hasResourceAccessRights: boolean = false;
  hasDeveloperRights: boolean = false;
  hasManagerRights: boolean = false;
  userCache: { [id: string]: any } = {};
  private dialogRef1?: MatDialogRef<GenericConfirmationDialogComponent>;
  
  constructor(
    public dialogRef: MatDialogRef<ViewBugComponent>,
    
    @Inject(MAT_DIALOG_DATA) public data: any,
    private bugmoduleservice: BugModuleService,
    private userDetailService: UserDetailsService,
    public userservice: UserService,
    private toast: ToastrService,
    private dialog: MatDialog
  ) {
    this.issueId = data;
  }

  getIssueBadgeStyle(issueType: string): string {                 
    const colors = {'Enhancement': 'color: #388E3C;font-size: 14px;',
      'Bug': 'color: #D32F2F;font-size: 14px;',
    };
    return colors[issueType] || 'background: #f0f0f0; color: #333';
  }

  ngOnInit(): void {
    this.getBugById();
  }

  stageFlows = {
    Bug: ['Reported', 'Resolving', 'Resolved','Decline'],
    Enhancement: ['Reported', 'Developing', 'Developed','Decline'],
    Question: ['Received_Question', 'Answered_Question'],
    Feedback: ['Received_Feedback']
  };

  getBugById() {
    this.bugmoduleservice.getSingleBug(this.issueId).subscribe(
      (res) => {
        this.issue = res.body;
        this.updateStageSearch = this.issue.stage;

        // Role-based access — also now safe if dependent on issue
        this.hasResourceAccessRights = this.userDetailService.hasRole([
          'ROLE_SUPER_ADMIN',
          'ROLE_HUMAN_RESOURCE',
          'ROLE_PULSE_MANAGER',
          'ROLE_PULSE_DEVELOPER'
        ]);
        this.hasDeveloperRights = this.userDetailService.hasRole([
          'ROLE_PULSE_MANAGER',
          'ROLE_PULSE_DEVELOPER'
        ]);
        this.hasManagerRights = this.userDetailService.hasRole([
          'ROLE_PULSE_MANAGER'
        ]);
      },
      (err) => {
        console.error("Error fetching bug:", err);
      }
    );
  }


  getStagesForProgress(issue: BugReportDTO): string[] {
  const stages = this.stageFlows[issue.selectedIssue] || [];

  if (issue.stage === 'Decline') {
    return ['Decline'];
  }

  return stages.filter(stage => stage !== 'Decline');
}

getStages(issue: BugReportDTO): string[] {
  return this.stageFlows[issue.selectedIssue] || [];
}


  
updateStage(issue: BugReportDTO) {
  const updated = {
    bugId: issue.bugId,
    stage: this.updateStageSearch
  } as BugReportDTO;

  
  this.bugmoduleservice.updateStage(updated).subscribe({
    next: (response) => {
      this.toast.success(response.body.message, 'Success');
      issue.stage = this.updateStageSearch as IssueStage; // ✅ cast to enum
      // this.closeDialog();
    },
    error: () => {
      this.toast.error('Error occurred while updating the stage!', 'Error');
    }
  });
}

getUserbyId(id: string): string {
    const user = this.userCache[id];
    if (user) {
      return user.firstName + ' ' + user.lastName;
    } else {
      this.userservice.getUserByID(id).subscribe((res) => {
        this.userCache[id] = res.body;
      });
      return 'Loading...';
    }
  }

  updateInfo(issue: BugReportDTO) {
    const updatedInfo = {
      bugId: issue.bugId,
      treeloLink: issue.treeloLink,
      AdditionalInfo: issue.AdditionalInfo,
      pntComments: issue.pntComments,
      ...issue
    };
       this.bugmoduleservice.updateAdditionalInfo(updatedInfo).subscribe({
        next: () => {
          this.toast.success('Info updated successfully!', 'Success');
          this.closeDialog();
          
        },
        error: () => {
          this.toast.error('Failed to update info!', 'Error');
        }
      });
        
  }

  notify(issue: BugReportDTO) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      header: 'Mail Employee',
      text: `Are you sure you want to mail all employees?`
    };
    dialogConfig.panelClass = 'activate-employee';

    this.dialogRef1 = this.dialog.open(GenericConfirmationDialogComponent, dialogConfig);

    this.dialogRef1.afterClosed().subscribe((res) => {
      if (res === 'Yes') {
        this.bugmoduleservice.notifyAll(issue).subscribe({
          next: (response) => {
            this.toast.success(response.body.message, 'Success');
            this.closeDialog();
          },
          error: () => {
            this.toast.error('Error occurred while sending the notification!', 'Error');
          }
        });
        }
    });
  }

  openImage(issue: BugReportDTO) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '83%';
    dialogConfig.height = '90%';
    dialogConfig.data = issue.photo;
    dialogConfig.panelClass = 'activate-employee';

    this.dialog.open(ImageDialogComponent, dialogConfig);
  }

  handleKeyPress(event: KeyboardEvent) {
    switch (event.key) {
      case 'Escape':
        this.closeDialog();
        break;
    }
  }

  ifOverflow(e: HTMLElement): boolean {
    return e.scrollWidth > e.clientWidth;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
